import controller from './menuBar.controller';
import template from './menuBar.html';
import './menuBar.scss';
/**
 * @ngdoc component
 * @name menuBar
 * @description
 * The menu bar component of the app.
 *
 * @memberof rootModule
 */
export default {
  /**
   * The controller class for the component.
   * @type {MenuBarController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {Object} item The menu item to be shown.
   */
  bindings: {
    item: '<',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/menuBar/menuBar.component.js